import { REGISTER, LOGIN, INTEREST } from "../constants/auth.action.types";

export default (state = {}, action) => {
  switch (action.type) {
    case REGISTER:
    case INTEREST:
      return {
        ...state,
        errors: action.error ? action.payload.error : null,
        interset_resp: action.error ? null : action.payload
      };
    case LOGIN:
      return {
        ...state,
        errors: action.error ? action.payload.error : null,
        user: action.error ? null : action.payload
      };
    default:
      return state;
  }
};
